'use strict';
import * as $j_app$002edata$002e$002dPayment$002dDetails$0024$002dEuropean$002dUnion$002dS$002dE$002dP$002dA from "./app.data.-Payment-Details$-European-Union-S-E-P-A.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PaymentDetails$EuropeanUnionSEPA$() {
}
export { $c_Lapp_data_PaymentDetails$EuropeanUnionSEPA$ as $c_Lapp_data_PaymentDetails$EuropeanUnionSEPA$ };
$p = $c_Lapp_data_PaymentDetails$EuropeanUnionSEPA$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PaymentDetails$EuropeanUnionSEPA$;
/** @constructor */
function $h_Lapp_data_PaymentDetails$EuropeanUnionSEPA$() {
}
export { $h_Lapp_data_PaymentDetails$EuropeanUnionSEPA$ as $h_Lapp_data_PaymentDetails$EuropeanUnionSEPA$ };
$h_Lapp_data_PaymentDetails$EuropeanUnionSEPA$.prototype = $p;
$p.n = (function() {
  return "EuropeanUnionSEPA";
});
$p.bKT = (function(x$0) {
  return new $j_app$002edata$002e$002dPayment$002dDetails$0024$002dEuropean$002dUnion$002dS$002dE$002dP$002dA.$c_Lapp_data_PaymentDetails$EuropeanUnionSEPA(x$0.e(0), x$0.e(1));
});
$p.U = (function(p) {
  return this.bKT(p);
});
var $d_Lapp_data_PaymentDetails$EuropeanUnionSEPA$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PaymentDetails$EuropeanUnionSEPA$, "app.data.PaymentDetails$EuropeanUnionSEPA$", ({
  EA: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_PaymentDetails$EuropeanUnionSEPA$ as $d_Lapp_data_PaymentDetails$EuropeanUnionSEPA$ };
var $n_Lapp_data_PaymentDetails$EuropeanUnionSEPA$;
function $m_Lapp_data_PaymentDetails$EuropeanUnionSEPA$() {
  if ((!$n_Lapp_data_PaymentDetails$EuropeanUnionSEPA$)) {
    $n_Lapp_data_PaymentDetails$EuropeanUnionSEPA$ = new $c_Lapp_data_PaymentDetails$EuropeanUnionSEPA$();
  }
  return $n_Lapp_data_PaymentDetails$EuropeanUnionSEPA$;
}
export { $m_Lapp_data_PaymentDetails$EuropeanUnionSEPA$ as $m_Lapp_data_PaymentDetails$EuropeanUnionSEPA$ };
//# sourceMappingURL=app.data.-Payment-Details$-European-Union-S-E-P-A$.js.map
